import React, { useEffect, useState } from 'react'
import { postContratosDeUnUser } from '../../../services/PaginaRuta'
import ModalContratosXUsuarioN from './ModalContratosXUsuarioN'
import TablaListaDeSeleccionEmpresasXUsuario from './TablaListaDeSeleccionEmpresasXUsuario'
import ModalListaDeSeleccionContratosXEmpresaN from './ModalListaDeSeleccionContratosXEmpresaN'

const ModalListaDeSeleccionEmpresasXUsuario = ({setmodalOnEmpresasXUsuario,passDataUser, passDataContratoUser}) => {
    const [modalOnContratosXUsuario, setmodalOnContratosXUsuario]=useState(false)
    const [dataEmpresaXUsuario, setdataEmpresaXUsuario]=useState([])
    const [actializarempresasxusuarios, setactializarempresasxusuarios]=useState({
        MENNIT: '',
        MPTDoc: "",
        MPCedu: "",
        MTCodP: "",
        MTUCod: ""
    })

    const passactualizarinfo=(data)=>{
        setactializarempresasxusuarios(data)
    }

    const handleClickContratosXUsuario=()=>{
        setmodalOnContratosXUsuario(true)
    }

    const passDataEmpresasXUsuario=(data)=>{
        passDataContratoUser(data)
        setmodalOnEmpresasXUsuario(false)
    }

    const handleCancelarClick=()=>{
        setmodalOnEmpresasXUsuario(false)
    }
    const handleOnsubmitBuscar=(e)=>{
        e.preventDefault()
        const body={
            MPCedu:passDataUser.numeroUser,
            MPTDoc:passDataUser.tipoDocumentoUser,
            MENOMB:e.target.nitUser.value,
            MENNIT:'',
            //varMEestado:'0',
            //varMPstatus:'A'
        }
        postContratosDeUnUser(body).then((res)=>{
            //console.log(res.data,'data del user')
            setdataEmpresaXUsuario(res.data)
        })
    }
    useEffect(()=>{
        const body={
            MPCedu:passDataUser.numeroUser,
            MPTDoc:passDataUser.tipoDocumentoUser,
            MENNIT:'',
            //varMEestado: '0',
            //MPstatus:'A',
            MENOMB:''
        }
        postContratosDeUnUser(body).then((res)=>{
            //console.log(res.data,'data del user')
            setdataEmpresaXUsuario(res.data)
        })
    },[actializarempresasxusuarios])

  return (
    <>
        <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-[#f4f6fa]"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
        >
        <div className="sm:h-[calc(100%)] max-w-7xl  mx-auto relative w-auto pointer-events-none ">
            <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-1 border-b border-gray-200 rounded-t-md bg-[#9e56fe]">
                <h5
                className="text-xl font-medium leading-normal text-white"
                id="exampleModalScrollableLabel"
                >
                Lista de Selección Empresa X Usuario
                </h5>
                <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
                >
                X
                </button>
            </div>
            <div className="flex-auto overflow-y-auto relative p-4">
                
                <div className="flex py-2 text-left">
                    <div className="w-1/3  px-4">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Tipo de Documento
                    </label>
                    <div className="flex">
                        <input
                        //   onChange={searchUserId}
                        //defaultValue={props.userDate[0].ProEmpCod}
                        defaultValue={passDataUser.tipoDocumentoUser}
                        disabled={true}
                        type="text"
                        name="cedula"
                        autoComplete="off"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        />
                    </div>
                    </div>
                    <div className="w-1/3  px-4">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        N° del Documento
                    </label>
                    <div className="flex">
                        <input
                        //   onChange={searchUserId}
                        //defaultValue={props.userDate[0].ProEmpCod}
                        defaultValue={passDataUser.numeroUser}
                        disabled={true}
                        type="text"
                        name="cedula"
                        autoComplete="off"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-white bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        />
                    </div>
                    </div>
                    <form className="w-1/3  px-4 flex" onSubmit={handleOnsubmitBuscar}>
                    <div className="w-2/3  px-4">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                        Contrato
                    </label>

                    <div className="flex">
                        <input
                        //   onChange={searchUserId}
                        //defaultValue={props.userDate[0].ProEmpCod}
                        //defaultValue={props.userDate.ProEmpCod}
                        type="text"
                        name="nitUser"
                        autoComplete="off"
                        className="form-control block w-full px-3 py-0.5 text-base font-normal  text-gray-900  bg-[#eaebec] bg-clip-padding border border-solid border-gray-300  rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-600 focus:outline-none "
                        id="exampleFormControlInput1"
                        placeholder=""
                        />
                    </div>
                    </div>
                    
                    
                    <div className="w-1/3  px-4">
                    <label className="form-label block mb-2 text-gray-900 font-medium pt-6">
                        
                    </label>
                    <div className="flex">
                    <button
                        type="submit"
                        className="inline-block px-3 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                        >
                        Buscar
                        </button>
                    </div>
                    </div>
                    </form>
                </div>
                
                
                <div className="flex flex-col">
                <div className="overflow-x-auto ">
                    <div className="py-2 inline-block min-w-full sm:px-6 ">
                    <div className="overflow-hidden">
                        <table className="min-w-full text-center">
                        <thead className="border-b bg-gray-200">
                            <tr>
                            <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-1"
                            >
                                
                            </th>
                            <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-1"
                            >
                                Contrato
                            </th>
                            <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-1"
                            >
                                Código Usua.
                            </th>
                            <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-1"
                            >
                                Descripción 
                            </th>      
                            <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-1"
                            >
                                Cód Tip. Afi.
                            </th>      
                            <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-1"
                            >
                                Tipo de Afiliado 
                            </th>               
                            <th
                                scope="col"
                                className="text-sm font-medium text-gray-900 px-4 py-1"
                            >
                                N.I.T 
                            </th>                
                            </tr>
                        </thead>
                        <tbody>
                            {
                                dataEmpresaXUsuario.map((item,index)=>(
                                    <TablaListaDeSeleccionEmpresasXUsuario key={index} item={item} passDataEmpresasXUsuario={passDataEmpresasXUsuario}/>
                                ))
                            }
                            
                        </tbody>
                        </table>
                    </div>
                    </div>
                </div>
                </div>
            </div>
            
            <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-300 rounded-t-md ">
              <div className="text-right">
                <button
                  type="button"
                  onClick={handleClickContratosXUsuario}
                  className="inline-block px-4 py-1.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out "
                >
                  Adicionar Empresa a Usuario
                </button>
              </div>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="inline-block px-4 py-1.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
            </div>
            </div>
        </div>
        </div>
        {/* {modalOnContratosXUsuario? <ModalContratosXUsuarioN setmodalOnContratosXUsuario={setmodalOnContratosXUsuario} passDataUser={passDataUser} passactualizarinfo={passactualizarinfo}/>:null} */}
        {modalOnContratosXUsuario? <ModalListaDeSeleccionContratosXEmpresaN setmodalOnContratosXUsuario={setmodalOnContratosXUsuario} passDataUser={passDataUser} passactualizarinfo={passactualizarinfo}/>:null}
    </>
  )
}

export default ModalListaDeSeleccionEmpresasXUsuario